<template>
	<v-sheet
		color="error"
		rounded
	>
		<v-card
			variant="outlined"
			elevation="0"
		>
			<v-card-title>
				<v-row>
					<v-col>
						<v-icon
							color="error"
							size="20.35"
							icon="$closeCircle"
						/>
						<translate class="text-error">
							Payment is unsuccessful or unprocessed
						</translate>
					</v-col>
				</v-row>
			</v-card-title>
			<v-card-subtitle>
				<translate>
					To pay the outstanding amount your payment has to be complete
				</translate>
			</v-card-subtitle>
		</v-card>
	</v-sheet>
</template>

<script>

export default {
	name: 'AdyenFailureCard'
};
</script>
